import {Injectable} from '@angular/core'
import {EffectUtil, SimpleRedirectEffectType} from '../../shared/store/effect-util'
import {Samoobsluga} from '../../shared/services/samoobsluga/types/samoobsluga'
import {pobierzDaneZgloszeniaSuccess, pobierzParametryAdmin, pobierzToggles, rozpocznijSamoobsluge} from './init.actions';
import {Actions, createEffect, ofType} from '@ngrx/effects';
import {map, mergeMap, tap} from 'rxjs/operators';
import {of, zip} from 'rxjs';
import {adminParametry} from '../../shared/services/admin/admin-parametry';
import {aktualizujParametrBiznesowy} from '../../shared/store/parametry/parametryBiznesowe.actions';
import {Store} from '@ngrx/store';
import {AdminService} from '../../shared/services/admin/admin.service';
import {TenantService} from '../../shared/services/tenant/tenant.service';
import {TogglesService} from '../../shared/services/toggles/toggles.service';
import {aktualizuToggle} from '../../shared/store/toggles/toggles.actions';
import {SamoobslugaService} from "../../shared/services/samoobsluga/samoobsluga.service";
import {pobierzDaneZgloszenia} from "../../shared/store/samoobsluga/samoobsluga.actions";

@Injectable()
export class InitEffects {

  constructor(
    private actions$: Actions,
    private effectUtil: EffectUtil,
    private store: Store,
    private adminService: AdminService,
    private togglesService: TogglesService,
    private tenantService: TenantService,
    private samoobslugaService: SamoobslugaService,
  ) {}

  pobierzParametryBiznesowe$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(pobierzParametryAdmin),
        mergeMap(() => {
          const paramList = [adminParametry.MINIMALNA_WARTOSC_ROSZCZENIA, adminParametry.PARAMETR_CC_URL_KEY, adminParametry.PARAMETR_KN_URL_KEY]
          if (this.tenantService.isTenantCC()) {
            paramList.push(adminParametry.PARAMETR_ZGLOSZENIE_URL_KEY)
          }
          else {
            paramList.push(adminParametry.PARAMETR_PAK_URL_KEY)
          }
          return zip(
            this.adminService.pobierzParametr(paramList)
          )
        }),
        tap(([listaParametrow]) => {
          for (const [nazwa, wartosc] of Object.entries(listaParametrow)) {
            this.store.dispatch(aktualizujParametrBiznesowy({nazwa, wartosc}))
          }
        })
      );
    }, {dispatch: false}
  );
  pobierzParametryAdmin$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(pobierzDaneZgloszeniaSuccess),
        map(() => {
          return pobierzParametryAdmin()
        })
      );
    }
  );
  pobierzToggles$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(pobierzDaneZgloszeniaSuccess),
        map(() => {
          return pobierzToggles()
        })
      );
    }
  );
  pobierzParametryToggle$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(pobierzToggles),
        mergeMap(() => {
          return zip(this.togglesService.pobierzToggles())
        }),
        tap(([lista]) => {
          this.store.dispatch(aktualizuToggle({toggles: lista}))
        })
      );
    }, {dispatch: false}
  );
  rozpocznijSamoobsluge$ = createEffect(
    () => {
      return this.actions$.pipe(
        ofType(rozpocznijSamoobsluge),
        mergeMap(({correlationId, samoobsluga}) => {
          return zip(of(correlationId), this.samoobslugaService.rozpocznij(correlationId))
        }),
        map(([correlationId, _]) => {
          return pobierzDaneZgloszenia({
            daneZgloszeniaZapytanie: {correlationId},
            nastepnaAkcja: (samoobsluga: Samoobsluga) => pobierzDaneZgloszeniaSuccess(samoobsluga)
          })
        })
      )
    }
  );
  pobierzDaneZgloszeniaSuccessRedirect$: SimpleRedirectEffectType<Samoobsluga> = this.effectUtil.createRedirectEffect(pobierzDaneZgloszeniaSuccess, 'procesUszkodzen');


}
